import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(public dialog: MatDialog) {}
  // the component that you need to render in the model
  openDialog(component) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'primary-model';
    dialogConfig.width = '280px';
    dialogConfig.maxWidth = '1324px';
    dialogConfig.backdropClass = 'primary-backdrop';
    dialogConfig.width = '100%';
    const dialogRef = this.dialog.open(component, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
